const subServiceContent = {
  iprSolutionsStartups: {
    // 	subServices: {
    //   title: "IPR Solutions for Startups",
    //   description:
    // 	"At Lifeintelect, we provide tailored IPR Solutions for Startups to help early-stage companies build robust IP foundations, attract investors, and scale sustainably. Our strategic guidance supports you from ideation to exit, ensuring your intellectual property drives growth and competitive advantage. Ready to strengthen your startup’s IP with Lifeintelect? Let's get started!",
    subServices: {
      ipStrategyRoadmap: {
        title: "IP Strategy & Roadmap for Startups",
        description:
          "At Lifeintelect, we help startup founders create customized IP strategies that align with their business model, product development cycle, and funding goals. We begin by assessing your innovations, business objectives, and market positioning. Our experts then identify protectable IP assets, prioritize filing strategies, and set timelines that align with commercial milestones, ensuring a structured roadmap to secure and grow your IP portfolio.",
        process: [
          {
            title: "Business Assessment",
            description:
              "Analyzing your startup’s business model, product cycle, and funding goals.",
          },
          {
            title: "Innovation Identification",
            description:
              "Identifying protectable innovations and potential IP assets.",
          },
          {
            title: "Filing Prioritization",
            description:
              "Prioritizing IP filings based on market needs and budget constraints.",
          },
          {
            title: "Timeline Development",
            description:
              "Setting timelines for IP protection aligned with commercial milestones.",
          },
          {
            title: "Roadmap Integration",
            description:
              "Creating a strategic IP roadmap to support long-term growth and competitiveness.",
          },
        ],
        closing:
          "Lifeintelect’s IP Strategy & Roadmap service empowers startups to build a strong IP foundation for success. Ready to create your IP roadmap with Lifeintelect? Let's get started!",
      },
      costEffectiveProtection: {
        title: "Cost-Effective IP Protection",
        subHeading: "Cost-Effective IP Protection",
        subTitle: " ",
        description:
          "At Lifeintelect, we offer tailored solutions to protect your startup’s intellectual property within limited budgets. We advise on strategic filing in critical markets, leveraging provisional applications, phased protection strategies, and government subsidies or startup incentives. Our approach ensures that your IP protection is robust and cost-efficient, maximizing value without compromising quality.",
        process: [
          {
            title: "Budget Analysis",
            description:
              "Assessing your startup’s budget to tailor cost-effective IP protection strategies.",
          },
          {
            title: "Market Selection",
            description:
              "Advising on strategic filing in critical markets to optimize protection.",
          },
          {
            title: "Provisional Applications",
            description:
              "Utilizing provisional applications to secure early protection at lower costs.",
          },
          {
            title: "Subsidy Identification",
            description:
              "Identifying government subsidies and startup incentives to reduce filing costs.",
          },
          {
            title: "Phased Protection",
            description:
              "Implementing phased protection strategies to spread costs over time.",
          },
        ],
        closing:
          "Lifeintelect’s Cost-Effective IP Protection service ensures your startup’s IP is secured without breaking the bank. Ready to protect your IP affordably with Lifeintelect? Let's get started!",
      },
      ipDueDiligenceInvestors: {
        title: "IP Due Diligence for Investors",
        subHeading: "IP Due Diligence for Investors",
        subTitle: "Build Investor Trust. Validate Your Value.",
        description:
          "IP due diligence is a make-or-break moment in funding rounds. Clarity on ownership, scope, and enforceability can drive investment decisions—and accelerate deal flow.",
        processTitle: "Investor-Ready Insights:",
        process: [
          {
            description:
              "Portfolio review for strength, scope, and legal standing",
          },
          {
            description: "Ownership verification and assignment checks",
          },
          {
            description:
              "Identification of potential red flags and compliance issues",
          },
          {
            description:
              "Clear, structured due diligence reports for presentations and negotiations",
          },
        ],
        closing: "Well-documented IP earns credibility—and capital.",
      },
      ipLicensingCommercialization: {
        title: "IP Licensing & Commercialization",
        subHeading: "IP Licensing & Commercialization",
        subTitle: "Monetize Innovation Early. Multiply Reach.",
        description:
          "IP doesn’t need to wait for scale to deliver value. Strategic licensing opens doors to early revenue and industry partnerships.",
        processTitle: "Commercial Value Extraction Strategies:",
        process: [
          {
            description:
              "Identification of potential licensees, co-developers, or acquirers",
          },
          {
            description:
              "Structuring of licensing terms to maximize flexibility and return",
          },
          {
            description: "Advice on tech transfer pathways and revenue models",
          },
          {
            description:
              "Support through negotiation, compliance, and implementation",
          },
        ],
        closing: "Turn innovation into income—without giving away control",
      },
      raisingAwarenessFunding: {
        title: "Funding & Visibility Through IP",
        subHeading: "Funding & Visibility Through IP",
        subTitle: "Stand Out in Accelerators. Win Over Funders.",
        description:
          "A strong IP narrative can differentiate your startup in competitive funding environments. The right messaging turns patents into pitch power.",
        processTitle: "Tools to Strengthen Your IP Story:",
        process: [
          {
            description:
              "Pitch decks and innovation briefs featuring core IP assets",
          },
          {
            description: "IP-backed market potential analysis",
          },
          {
            description:
              "Application support for grants, accelerator programs, and incubators",
          },
          {
            description: "Strategic framing of IP as a business advantage",
          },
        ],
        closing: "Showcase your IP not just as protection—but as potential.",
      },
      startupIpPortfolio: {
        title: "Startup IP Portfolio Management",
        subHeading: "Startup IP Portfolio Management",
        subTitle: "Centralized Oversight. Continuous Alignment",
        description:
          "Juggling product launches, fundraising, and IP filings is a challenge for any founder. Efficient management ensures that nothing slips through the cracks.",
        processTitle: "Smart Portfolio Management Includes:",
        process: [
          {
            description:
              "Central tracking of filings, renewals, and jurisdictional coverage",
          },
          {
            description:
              "Document control for assignments, licensing, and disclosures",
          },
          {
            description:
              "Portfolio audits to ensure alignment with evolving product strategy",
          },
          {
            description:
              "Alerts and dashboards for key deadlines and legal events",
          },
        ],
        closing: "Stay organized. Stay compliant. Stay on course",
      },
      ipRiskManagement: {
        title: "IP Risk Management for Startups",
        subHeading: "IP Risk Management for Startups",
        subTitle: "Avoid Costly Mistakes. Protect What’s Yours.",
        description:
          "Legal risks can derail momentum. Early-stage ventures benefit from preventive IP risk planning before disputes arise.",
        processTitle: "Early-Stage IP Risk Controls:",
        process: [
          {
            description:
              "Freedom-to-operate (FTO) analysis to avoid infringement",
          },
          {
            description:
              "Agreement reviews for co-founders, employees, and contractors",
          },
          {
            description:
              "Portfolio audits to ensure alignment with evolving product strategy",
          },
          {
            description:
              "Trade secret protocols and internal confidentiality safeguards",
          },
          {
            description:
              "Trade secret protocols and internal confidentiality safeguards",
          },
          {
            description:
              "Ownership clarity through proper inventor documentation and IP assignments",
          },
        ],
        closing:
          "Mitigate risk before it scales—and protect your competitive edge.",
      },
    },
    // iprSolutionsStartups: {
      title: "IP SOLUTIONS FOR STARTUPS",
      subtitle: "Build Smart. Protect Early. Scale Confidently.",
      description:
        "Startups operate in fast-moving, high-risk environments where intellectual property can be a game-changer—or a blind spot. LifeIntelect delivers tailored IP strategies for early-stage ventures, helping founders protect what they build, attract investors, and unlock long-term value. From idea to exit, every stage is supported with insight, structure, and strategic foresight.",
      service_1: {
        title: "IP Strategy & Roadmap",
        subtitle: "Start Right. Protect Smart.",
        description:
          "An effective IP roadmap lays the foundation for differentiation, defensibility, and future growth. For startups, timing and alignment with business goals are everything.",
        processTitle: "Core Elements of a Smart Startup IP Plan:",
        process: [
          {
            description:
              "Structured roadmap tied to product development and funding stages",
          },
          {
            description:
              "Identification and prioritization of protectable innovations",
          },
          {
            description: "Timeline and jurisdiction planning for filings",
          },
          {
            description:
              "Strategic alignment with go-to-market and commercialization goals",
          },
        ],
        closing:
          "A proactive IP plan sets the stage for scaling with confidence.",
      },
      service_2: {
        title: "IP Due Diligence for Investors",
        subtitle: "Build Investor Trust. Validate Your Value.",
        description:
          "IP due diligence is a make-or-break moment in funding rounds. Clarity on ownership, scope, and enforceability can drive investment decisions—and accelerate deal flow.",
        processTitle: "Investor-Ready Insights:",
        process: [
          {
            description:
              "Portfolio review for strength, scope, and legal standing",
          },
          {
            description: "Ownership verification and assignment checks",
          },
          {
            description:
              "Identification of potential red flags and compliance issues",
          },
          {
            description:
              "Clear, structured due diligence reports for presentations and negotiations",
          },
        ],
        closing: "Well-documented IP earns credibility—and capital.",
      },
      service_3: {
        title: "IP Licensing & Commercialization.",
        subtitle: "Monetize Innovation Early. Multiply Reach.",
        description:
          "IP doesn’t need to wait for scale to deliver value. Strategic licensing opens doors to early revenue and industry partnerships.",
        processTitle: "Commercial Value Extraction Strategies:",
        process: [
          {
            description:
              "Identification of potential licensees, co-developers, or acquirers",
          },
          {
            description:
              "Structuring of licensing terms to maximize flexibility and return",
          },
          {
            description: "Advice on tech transfer pathways and revenue models",
          },
          {
            description:
              "Support through negotiation, compliance, and implementation",
          },
        ],
        closing: "Turn innovation into income—without giving away control",
      },
      service_4: {
        title: "Funding & Visibility Through IP",
        subtitle: "Stand Out in Accelerators. Win Over Funders.",
        description:
          "A strong IP narrative can differentiate your startup in competitive funding environments. The right messaging turns patents into pitch power.",
        processTitle: "Tools to Strengthen Your IP Story:",
        process: [
          {
            description:
              "Pitch decks and innovation briefs featuring core IP assets",
          },
          {
            description: "IP-backed market potential analysis",
          },
          {
            description:
              "Application support for grants, accelerator programs, and incubators",
          },
          {
            description: "Strategic framing of IP as a business advantage",
          },
        ],
        closing: "Showcase your IP not just as protection—but as potential.",
      },
      service_5: {
        title: "Startup IP Portfolio Management",
        subtitle: "Centralized Oversight. Continuous Alignment.",
        description:
          "Juggling product launches, fundraising, and IP filings is a challenge for any founder. Efficient management ensures that nothing slips through the cracks.",
        processTitle: "Smart Portfolio Management Includes:",
        process: [
          {
            description:
              "Central tracking of filings, renewals, and jurisdictional coverage",
          },
          {
            description:
              "Document control for assignments, licensing, and disclosures",
          },
          {
            description:
              "Portfolio audits to ensure alignment with evolving product strategy",
          },
          {
            description:
              "Alerts and dashboards for key deadlines and legal events",
          },
        ],
        closing: "Stay organized. Stay compliant. Stay on course",
      },
      service_6: {
        title: "IP Risk Management for Startups",
        subtitle: "Avoid Costly Mistakes. Protect What’s Yours.",
        description:
          "Legal risks can derail momentum. Early-stage ventures benefit from preventive IP risk planning before disputes arise.",
        processTitle: "Early-Stage IP Risk Controls:",
        process: [
          {
            description:
              "Freedom-to-operate (FTO) analysis to avoid infringement",
          },
          {
            description:
              "Agreement reviews for co-founders, employees, and contractors",
          },
          {
            description:
              "Portfolio audits to ensure alignment with evolving product strategy",
          },
          {
            description:
              "Trade secret protocols and internal confidentiality safeguards",
          },
          {
            description:
              "Ownership clarity through proper inventor documentation and IP assignments",
          },
        ],
        closing:
          "Mitigate risk before it scales—and protect your competitive edge.",
      },
    // },
  },
};

export default subServiceContent;
